import React from "react";

export const LoaderTwo = () => {
    return (
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
            <div className="typing-container">
                <div className="loader-typing-2"></div>
            </div>
            <div className="loader-words">Bot is typing</div>
        </div>
    );
};
